import 'reactjs-popup/dist/index.css';
import './Tooltip.module.css';
import { Popup } from 'reactjs-popup';
import { PopupProps } from 'reactjs-popup/dist/types';

export const Tooltip = (props: PopupProps) => {
  return <Popup on='hover' position='top center' {...props} />;
};
